const modelNodes = {
  initial: [0, 2, 3, 4, 5, 6, 21, 22, 23, 38, 39, 40, 52, 53, 54, 948, 949, 950],
  "1.5×0.75m": {
    nodes: [0, 2, 3, 4, 5, 6, 21, 22, 23, 38, 39, 40, 52, 53, 54, 948, 949, 950],
    heater: {
      External: {
        Standard: {
          nodes: [634, 635, 636, 644, 652],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [868, 869, 870, 878, 886],
              initial: [766, 767, 768, 776],
            },
            "90-Degree Heater Connections": {
              nodes: [165, 166, 167, 175, 183],
              initial: [634, 635, 636, 644, 652],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [259, 260, 261],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [458, 459, 460, 468, 476],
                  initial: [353, 354, 355, 363],
                },
              }
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [672, 673, 674],
            },
          },
        },
        Medium: {
          nodes: [596, 597, 598, 606, 614],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [830, 831, 832, 840, 848],
              initial: [740, 741, 742, 750],
            },
            "90-Degree Heater Connections": {
              nodes: [127, 128, 129, 137, 145],
              initial: [596, 597, 598, 606, 614],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [273, 274, 275],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [420, 421, 422, 430, 438],
                  initial: [327, 328, 329, 337],
                },
              }
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [686, 687, 688],
            },
          },
        },
        Large: {
          nodes: [558, 559, 560, 568, 576],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [792, 793, 794, 802, 810],
              initial: [714, 715, 716, 724],
            },
            "90-Degree Heater Connections": {
              nodes: [83, 84, 85, 93, 104],
              initial: [558, 559, 560, 568, 576],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [287, 288, 289],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [379, 380, 381, 389, 397],
                  initial: [301, 302, 303, 311],
                },
              }
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [700, 701, 702],
            },
          },
        },
      },
    },
    interiorexterior: {
      liner: {
        nodes: [962, 963, 964, 1004, 1005, 1006],
      },
      lidCover: {
        Wooden: {
          nodes: [513, 514, 515],
        },
        Insulated: {
          nodes: [496, 497, 498],
        },
        Fibreglass: {
          nodes: [],
        },
      },
    },
    accessories: {
      flueDrain: {
        "High-Flow Drain Tap": {
          nodes: [203, 204, 205, 213, 221, 232],
        },
      },
      wooden: {
        "Mini Bar / Drink Holder": {
          nodes: [920, 921, 922],
        },
        "Stirring Paddle": {
          nodes: [544, 545, 546],
        },
        "Wide Bespoke Steps": {
          nodes: [934, 935, 936],
          initial: [4, 5, 6],
        },
        "Top Rim Decoration": {
          nodes: [1004, 1005, 1006],
        }
      },
      electrical: {
        "LED Underwater Lighting": {
          "1 LED Light": {
            nodes: [1087, 1088, 1089, 1097, 1105],
          },
          "2 LED Lights": {
            nodes: [1046, 1047, 1048, 1056, 1067, 1087, 1088, 1089, 1097, 1105],
          },
        },
        "Combined Massage System": {
          nodes: [1228, 1229, 1230, 1238, 1246, 1254, 1032, 1033, 1034],
        },
        "Hydro Massage System": {
          "1.1kW with 6 jets": {
            nodes: [1125, 1126, 1127, 1135, 1146, 1154, 1032, 1033, 1034],
          },
          "2.2kW with 10 jets": {
            nodes: [1178, 1179, 1180, 1188, 1196, 1204, 1032, 1033, 1034],
          },
        },
        "Air Bubble System": {
          nodes: [1278, 1279, 1280, 1288, 1296, 1304, 1032, 1033, 1034],
        },
      },
    },
  },
  "1.6x1m": {
    nodes: [
      0, 2, 1455, 1506, 1507, 1508, 1520, 1521, 1522, 1534, 1535, 1536, 1548, 1549, 1550, 2454, 2455, 2456
    ],
    heater: {
      External: {
        Standard: {
          nodes: [2140, 2141, 2142, 2150, 2158],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [2374, 2375, 2376, 2384, 2392],
              initial: [2272, 2273, 2274, 2282],
            },
            "90-Degree Heater Connections": {
              nodes: [1792, 1793, 1794, 1802, 1810],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [1830, 1831, 1832],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [2026, 2027, 2028, 2036, 2044],
                  initial: [1924, 1925, 1926, 1934],
                },
              }
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [2178, 2179, 2180],
            },
          },
        },
        Medium: {
          nodes: [2102, 2103, 2104, 2112, 2120],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [2336, 2337, 2338, 2346, 2354],
              initial: [2246, 2247, 2248, 2256],
            },
            "90-Degree Heater Connections": {
              nodes: [1754, 1755, 1756, 1764, 1772],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [1844, 1845, 1846],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [1988, 1989, 1990, 1998, 2006],
                  initial: [1898, 1899, 1900, 1908],
                },
              }
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [2192, 2193, 2194],
            },
          },
        },
        Large: {
          nodes: [2064, 2065, 2066, 2074, 2082],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [2298, 2299, 2300, 2308, 2316],
              initial: [2220, 2221, 2222, 2230],
            },
            "90-Degree Heater Connections": {
              nodes: [1716, 1717, 1718, 1726, 1734],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [1858, 1859, 1860],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [1950, 1951, 1952, 1960, 1968],
                  initial: [1872, 1873, 1874, 1882],
                },
              }
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [2206, 2207, 2208],
            },
          },
        },
      },
    },
    interiorexterior: {
      liner: {
        nodes: [1688, 1689, 1690, 1562, 1563, 1564],
      },
      lidCover: {
        Wooden: {
          nodes: [1590, 1591, 1592],
        },
        Insulated: {
          nodes: [1576, 1577, 1578],
        },
        Fibreglass: {
          nodes: [],
        },
      },
    },
    accessories: {
      flueDrain: {
        "High-Flow Drain Tap": {
          nodes: [1456, 1457, 1458, 1466, 1474, 1482],
        },
      },
      wooden: {
        "Mini Bar / Drink Holder": {
          nodes: [1646, 1647, 1648],
        },
        "Stirring Paddle": {
          nodes: [1618, 1619, 1620],
        },
        "Wide Bespoke Steps": {
          nodes: [1660, 1661, 1662],
          initial: [1506, 1507, 1508],
        },
        "Top Rim Decoration": {
          nodes: [1688, 1689, 1690],
        }
      },
      electrical: {
        "LED Underwater Lighting": {
          "1 LED Light": {
            nodes: [2506, 2507, 2508, 2516, 2524],
          },
          "2 LED Lights": {
            nodes: [2468, 2469, 2470, 2478, 2486, 2506, 2507, 2508, 2516, 2524],
          },
        },
        "Combined Massage System": {
          nodes: [2644, 2645, 2646, 2654, 2662, 2670],
        },
        "Hydro Massage System": {
          "1.1kW with 6 jets": {
            nodes: [2544, 2545, 2546, 2554, 2562, 2570, 2412, 2413, 2414],
          },
          "2.2kW with 10 jets": {
            nodes: [2594, 2595, 2596, 2604, 2612, 2620, 2412, 2413, 2414],
          },
        },
        "Air Bubble System": {
          nodes: [2694, 2695, 2696, 2704, 2712, 2720, 2412, 2413, 2414],
        },
      },
    },
  },
  "1.9x1.2m": {
    nodes: [
      0, 2, 2744, 2745, 2746, 2747, 2809, 2810, 2811, 2873, 2874, 2875, 3697, 3698, 3699, 3707, 3715, 3975, 3976, 3977
    ],
    heater: {
      External: {
        Standard: {
          nodes: [3411, 3412, 3413, 3421, 3429],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [3645, 3646, 3647, 3655, 3663],
              initial: [3543, 3544, 3545, 3553],
            },
            "90-Degree Heater Connections": {
              nodes: [3075, 3076, 3077, 3085, 3093],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [3113, 3114, 3115],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [3309, 3310, 3311, 3319, 3327],
                  initial: [3207, 3208, 3209, 3217],
                },
              }
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [3449, 3450, 3451],
            },
          },
        },
        Medium: {
          nodes: [3385, 3386, 3387, 3395],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [3607, 3608, 3609, 3617, 3625],
              initial: [3517, 3518, 3519, 3527],
            },
            "90-Degree Heater Connections": {
              nodes: [3037, 3038, 3039, 3047, 3055],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [3127, 3128, 3129],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [3271, 3272, 3273, 3281, 3289],
                  initial: [3181, 3182, 3183, 3191],
                },
              }
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [3463, 3464, 3465],
            },
          },
        },
        Large: {
          nodes: [3347, 3348, 3349, 3357, 3365],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [3569, 3570, 3571, 3579, 3587],
              initial: [3491, 3492, 3493, 3501],
            },
            "90-Degree Heater Connections": {
              nodes: [2999, 3000, 3001, 3009, 3017],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [3141, 3142, 3143],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [3233, 3234, 32325, 3243, 3251],
                  initial: [3155, 3156, 3157, 3165],
                },
              }
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [3477, 3478, 3479],
            },
          },
        },
      },
    },
    interiorexterior: {
      liner: {
        nodes: [],
      },
      lidCover: {
        Wooden: {
          nodes: [2985, 2986, 2987],
        },
        Insulated: {
          nodes: [2915, 2916, 2917],
        },
        Fibreglass: {
          nodes: [2887, 2888, 2889],
        },
      },
    },
    accessories: {
      flueDrain: {
        "High-Flow Drain Tap": {
          nodes: [2759, 2760, 2761, 2769, 2777, 2785],
        },
      },
      wooden: {
        "Mini Bar / Drink Holder": {
          nodes: [2957, 2958, 2959],
        },
        "Stirring Paddle": {
          nodes: [2929, 2930, 2931],
        },
        "Wide Bespoke Steps": {
          nodes: [2971, 2972, 2973],
          initial: [2745, 2746, 2747],
        },
      },
      electrical: {
        "LED Underwater Lighting": {
          "1 LED Light": {
            nodes: [3773, 3774, 3775, 3783, 3791],
          },
          "2 LED Lights": {
            nodes: [3735, 3736, 3737, 3745, 3753],
          },
        },
        "Combined Massage System": {
          nodes: [2823, 2824, 2825, 2833, 2841, 2849],
        },
        "Hydro Massage System": {
          "1.1kW with 6 jets": {
            nodes: [3811, 3812, 3813, 3821, 3829, 3837],
          },
          "2.2kW with 10 jets": {
            nodes: [3861, 3862, 3863, 3871, 3879, 3887],
          },
        },
        "Air Bubble System": {
          nodes: [3911, 3912, 3913,3921, 3929, 3937],
        },
      },
    },
  },
};

export default modelNodes;
